import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBNwApIOWKbCzpCXDxwhINl44FUhzFXR9g",
  authDomain: "talentcheck-online.firebaseapp.com",
  databaseURL: "https://talentcheck-online-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "talentcheck-online",
  storageBucket: "talentcheck-online.firebasestorage.app",
  messagingSenderId: "174586925862",
  appId: "1:174586925862:web:374f1bc226f7e551f627e7"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };